// Douglas Metal Finishing - Main JavaScript
// Bootstrap JS is already included via CDN

console.log('Douglas Metal Finishing - Site Loaded');

// Syntax highlighting (PrismJS) - progressive enhancement
try {
  if (window.Prism && typeof window.Prism.highlightAll === 'function') {
    // Initial highlight
    window.Prism.highlightAll();

    // Re-highlight code inside newly shown Bootstrap tabs (important for tabbed code-blocks)
    document.addEventListener('shown.bs.tab', function(e) {
      const targetSelector = e && e.target ? e.target.getAttribute('data-bs-target') : null;
      if (!targetSelector) return;
      const pane = document.querySelector(targetSelector);
      if (!pane) return;

      // Skip line-numbered blocks (they contain injected spans that Prism doesn't expect)
      if (pane.querySelector('pre.with-line-numbers .line-number')) return;

      if (typeof window.Prism.highlightAllUnder === 'function') {
        window.Prism.highlightAllUnder(pane);
      } else {
        window.Prism.highlightAll();
      }
    });
  }
} catch (_) {
  // no-op
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector(this.getAttribute('href'));
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
});

